import { Flame } from "lucide-react";

export default function StreakCard({ streak, studiedToday }) {
  const label = streak === 1 ? "1 day" : `${streak} days`;
  const hint = streak === 0 ? "Use any study tool today to start a streak." : studiedToday ? "You studied today. See you tomorrow!" : "Study today to keep your streak alive.";
  return (
    <div className={`streak-card${studiedToday ? " lit" : ""}`} data-testid="streak-card">
      <span className="streak-icon"><Flame size={18} /></span>
      <div>
        <strong data-testid="streak-count">{label}</strong>
        <small data-testid="streak-hint">{hint}</small>
      </div>
    </div>
  );
}
